// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_h8-0";
export var actionModalContentContainer = "_h8-1";
export var createTagButton = "_h8-2";
export var footerContainer = "_h8-7";
export var fullWidthDivider = "_h8-3";
export var hasCreateTagButton = "_h8-4";
export var noCreateTagButton = "_h8-5";
export var tagsContainer = "_h8-6";
export var tagsModalContentContainer = "_h8-8";